import { API_BASE_URL } from '../config';

const TOKEN_KEY = 'guest_feedback_token';
const GUEST_KEY = 'guest_feedback_guest';

async function api(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const token = getStoredToken();
  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data.detail;
    let message =
      typeof detail === 'string'
        ? detail
        : Array.isArray(detail)
          ? detail.map((d) => d.msg || JSON.stringify(d)).join(', ')
          : data.message || `Request failed (${response.status})`;
    if (response.status === 404 && path.includes('/auth/verify')) {
      message = 'Verification is temporarily unavailable. Please ask reception.';
    } else if (response.status === 401 && path.includes('/auth/verify')) {
      message = "That doesn't match our records. Please try again.";
    }
    throw new Error(message);
  }
  return data;
}

export function getStoredToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function storeSession(token, guest) {
  sessionStorage.setItem(TOKEN_KEY, token);
  if (guest) sessionStorage.setItem(GUEST_KEY, JSON.stringify(guest));
}

export function clearSession() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(GUEST_KEY);
}

export function fetchRoomGuests(room) {
  return api(`/guest-feedback/room/${encodeURIComponent(room)}/guests`);
}

export function verifyRoomGuest({ room, lastFour }) {
  return api('/guest-feedback/auth/verify-room', {
    method: 'POST',
    body: JSON.stringify({ room, lastFour }),
  });
}

export function verifyGuest({ guestId, lastFour, lastSix, room }) {
  return api('/guest-feedback/auth/verify', {
    method: 'POST',
    body: JSON.stringify({ guestId, lastFour, lastSix, room }),
  });
}

export function verifyKiosk({ lastSix }) {
  return api('/guest-feedback/auth/verify-kiosk', {
    method: 'POST',
    body: JSON.stringify({ lastSix }),
  });
}

export function fetchItinerary(date) {
  const q = date ? `?date=${encodeURIComponent(date)}` : '';
  return api(`/guest-feedback/me/itinerary${q}`);
}

export function fetchAvailableActivities(date) {
  const q = date ? `?date=${encodeURIComponent(date)}` : '';
  return api(`/guest-feedback/activities/available${q}`);
}

export function enrollInActivity(activityId, date) {
  const q = date ? `?date=${encodeURIComponent(date)}` : '';
  return api(`/guest-feedback/activities/${encodeURIComponent(activityId)}/enroll${q}`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function fetchMyFeedback() {
  return api('/guest-feedback/me/feedback');
}

export function submitTreatmentFeedback(payload) {
  return api('/guest-feedback/treatment', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function submitGeneralFeedback(payload) {
  return api('/guest-feedback/general', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function requestBuggy(payload) {
  return api('/guest-feedback/requests/buggy', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function requestHousekeeping(payload) {
  return api('/guest-feedback/requests/housekeeping', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
